/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSelfEmployedTransactionQueryResponse, GetSelfEmployedTransactionPathParams, GetSelfEmployedTransaction400, GetSelfEmployedTransaction401, GetSelfEmployedTransaction404, GetSelfEmployedTransaction500 } from "../entities/GetSelfEmployedTransaction";

function getGetSelfEmployedTransactionUrl(id: GetSelfEmployedTransactionPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/self-employed/transactions/${id}` as const }
  return res
}

/**
 * @description Возвращает данные операции.
 * `amount` — сумма после вычета, в копейках, без знака.
 * `date` — дата операции (RFC3339).
 * `status` (`success`, `waiting`, `canceled`) есть только у `order` и `payout`.
 * У `compensation`, `refund`, `dotaion` и `achivment` поля `status` нет.
 * `type`: `order`, `payout`, `compensation`, `refund`, `dotaion`, `achivment`.
 * `details` — разбивка суммы. Для `type=order`:
 * - `ride_amount` — стоимость поездки, в копейках
 * - `service_fee` — платёж Drivee, в копейках, со знаком
 * - `vat.rate` — ставка НДС, доля (`0.22` = 22%)
 * - `vat.amount` — сумма НДС, в копейках, со знаком
 * - `total` — итог, в копейках
 * - `reward` — награда за цель, если есть: `start_at`, `end_at`, `order_count`
 * Для типов без разбивки `details` равен `null`.
 * **Требования:**
 * - JWT access-токен водителя в заголовке `Authorization: Bearer <token>`. Водитель берётся
 * из токена (`user_id` в claims), заголовки `user-id` и `city-id` не нужны и не учитываются
 * Операция ищется по `id` и `user_id` из токена.
 * Чужая операция не отдаётся: ответ тот же `404`, что и для несуществующего `id`.
 * Так перебор `id` не показывает, есть ли операция у другого пользователя.
 * @summary Подробная информация о транзакции
 * {@link /api/v1/self-employed/transactions/:id}
 */
export async function getSelfEmployedTransaction(id: GetSelfEmployedTransactionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSelfEmployedTransactionQueryResponse, ResponseErrorConfig<GetSelfEmployedTransaction400 | GetSelfEmployedTransaction401 | GetSelfEmployedTransaction404 | GetSelfEmployedTransaction500>, unknown>({ method : "GET", url : getGetSelfEmployedTransactionUrl(id).url.toString(), ... requestConfig })
  return res.data
}